import { FormBuilder } from '../features/form-builder';

export function FormBuilderPage() {
  return (
    <div className="h-full">
      <FormBuilder />
    </div>
  );
}
